export default "__VITE_ASSET__CQtfUPLk__"